import { render, staticRenderFns } from "./DistributionFlow.vue?vue&type=template&id=b3807a7a&scoped=true&"
import script from "./DistributionFlow.vue?vue&type=script&lang=js&"
export * from "./DistributionFlow.vue?vue&type=script&lang=js&"
import style0 from "./DistributionFlow.vue?vue&type=style&index=0&id=b3807a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3807a7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3807a7a')) {
      api.createRecord('b3807a7a', component.options)
    } else {
      api.reload('b3807a7a', component.options)
    }
    module.hot.accept("./DistributionFlow.vue?vue&type=template&id=b3807a7a&scoped=true&", function () {
      api.rerender('b3807a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/DistributionFlow.vue"
export default component.exports